import {cloneDeep} from "lodash"
import {Poll, PollList} from "@irati/types"

export const addPoll = (polls: PollList, poll: Poll): PollList => {
  if (!poll) {
    return polls
  }

  const clonedItem = cloneDeep(polls)
  const clonedComment = cloneDeep(poll)

  clonedItem.results.unshift(clonedComment)

  return clonedItem
}

export const deletePoll = (polls: PollList, poll: Poll): PollList => {
  if (!poll) {
    return polls
  }

  const index = polls.results.findIndex((c) => c.uuid === poll.uuid)

  if (index < 0) {
    return polls
  }

  const clonedPolls = cloneDeep(polls)
  clonedPolls.results = clonedPolls.results.filter((c) => c.uuid !== poll.uuid)

  return clonedPolls
}
